<template>
    <router-view :style="{'background-color': backgroundColor}"></router-view>
</template>
<script>
    import moment from 'moment';
    import 'moment/locale/zh-cn';
    moment.locale('zh-cn');
    export default {
        data(){
            return {
                backgroundColor: '#00000000',
                association: this.$store.getters.association,
            }
        },
        mounted: function(){
            this.backgroundColor = !this.association ? '#00000000' : (this.association.bgcolor ? `#${this.association.bgcolor}` : '#00000000')
        },
        watch: {
            $route: function(to, from) {
                this.association = this.$store.getters.association
                this.backgroundColor = !this.association ? '#00000000' : (this.association.bgcolor ? `#${this.association.bgcolor}` : '#00000000')
            }
        },
    }
</script>
<style lang="scss">
    @import "./style/common.scss";
    #app {
        display: flex;
        flex-direction: column;
        width: 100%;
        min-height: 100%;
    }
    
    .scroll-to-top {
        position: fixed;
        right: 40px;
        bottom: 100px;
        width: 50px;
        height: 50px;
        z-index: 999;
        padding: 10px;
        background-color: #ccc;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url(./assets/imgs/img_top@2x.png);
        box-shadow: 2px 2px 5px #ccc;
        cursor: pointer;
    }

    #app > .content {
        min-height: 100vh;
        box-sizing: border-box;
        padding-top: 90px;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
    }

    #app > .content > .router-view {
        flex: 1;
    }

    .ant-notification {
        top: 100px !important;
        right: 12px !important; 
        margin-right: 0px;
    }

    @media only screen and (max-width: 1050px) {
        .ant-notification {
            top: 286px !important;
        }

    }
</style>
